import React, { PropTypes } from 'react';
import UserItem from './UserItem';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default class UserList extends React.Component {
  static propTypes = {
    users: ImmutablePropTypes.map.isRequired,
    selectedUsers: ImmutablePropTypes.map.isRequired,
    onSelected: PropTypes.func.isRequired,
  };

  render() {
    const { users, selectedUsers, onSelected } = this.props;
    const userArray = users.toArray();
    return (
      <div className="scroll">
        {userArray.length > 0 && (
          <table className="ui grey table">
            <thead>
              <tr>
                <th>Mail</th>
                <th>Nom</th>
                <th>Prénom</th>
              </tr>
            </thead>
            <tbody>
              {userArray.map(e => (
                <UserItem
                  key={e.id}
                  user={e}
                  selectedUsers={selectedUsers}
                  onSelected={onSelected}
                />
              ))}
            </tbody>
          </table>
        )}
        {userArray.length === 0 && (
          <div className="ui icon message">
            <i className="circle info icon" />
            <div className="content">
              <div className="header">Aucun utilisateur ne correspond</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/UserList.js